/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPhishingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-phishing"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.95 21.8Q10.95 21.8 9.55 21.8Q8.15 21.8 6.17 19.88Q4.2 17.95 4.2 15.15L4.2 9.6Q4.2 9.15 4.6 8.97Q5 8.8 5.33 9.13L9.35 13.13Q9.78 13.55 9.78 14.13Q9.78 14.7 9.35 15.13Q8.93 15.55 8.36 15.56Q7.8 15.57 7.38 15.15L7.03 14.82L7.03 15.15Q7.03 16.75 8.18 17.86Q9.32 18.98 10.95 18.98Q12.57 18.98 13.72 17.86Q14.88 16.75 14.88 15.15L14.88 12.1Q13.93 11.68 13.32 10.81Q12.72 9.95 12.72 8.9Q12.72 7.85 13.31 6.97Q13.9 6.1 14.88 5.67L14.88 2.6Q14.88 2.02 15.29 1.61Q15.7 1.2 16.27 1.2Q16.85 1.2 17.26 1.61Q17.68 2.02 17.68 2.6L17.68 5.67Q18.63 6.1 19.21 6.97Q19.8 7.85 19.8 8.9Q19.8 9.95 19.23 10.81Q18.65 11.68 17.68 12.1L17.68 15.15Q17.68 17.93 15.71 19.86Q13.75 21.8 10.95 21.8Z" fill={color} />
    </svg>
  );
}
